"use client";

import React, { useState } from "react";
import VideoCard from "@/revamp/organisms/VideoCard/VideoCard";
import { Testimonials, TestimonialsStudent } from "@/data/data";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";
import styles from "./VideoWrapper.module.scss";

export default function VideoWrapper({
  isMobile,
  isStudentStory=false,
  isRicsPage=false
}) {
  const [activeVideoId, setActiveVideoId] = useState<string | null>(null);
  const brandTestimonials=isRicsPage?Testimonials:TestimonialsStudent


  const Slides = brandTestimonials.map((testimonial, index) => (
    <VideoCard
      key={index}
      id={`${index + 1}`}
      testimonial={testimonial}
      activeVideoId={activeVideoId}
      ssetActiveVideoId={setActiveVideoId}
      isMobile={isMobile}
    />
  ));
  return (
    <>
      <Carousel
      id = "videotestimonial"
        children={Slides}
        config={{
          spaceBetween: 16,
          slidesPerView: 2,
          speed: 500,
          autoplay: {
            status: false,
          },
          pagination: {
            className: `${isStudentStory ? 'program_detail_carousel_pagination text-center' : ''} my-5`
          },
          breakpoints: {
            320: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            481: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 10
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 30
            },
            1900: {
              slidesPerView: 4,
              spaceBetween: 100
            }
          }
        }}
        className={styles.video_testimonial_carousel}

      />
    </>
  );
}
